export const body = {
    // width: "40%",
    textAlign: "center"
};

export const innerBody = {
    backgroundColor: "white",
    border: "1px solid black",
    padding: "5px",
    cursor: "pointer",
    textAlign: "center",
    marginBottom: "10px",
    marginTop: "10px"
};

export const title = {
    fontWeight: "bold"
};

export const image = {
    height: "150px",
    width: "150px",
    border: "1px solid black"
};

export const price = {
    paddingTop: "10px",
    textAlign: "right"
};

//MOBILE
export const mobile_innerBody = {
    backgroundColor: "white",
    border: "1px solid black",
    padding: "5px",
    cursor: "pointer",
    textAlign: "center"
};
